import { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { AppContext } from '../DataProviders/AppStateProvider';

/**
 * Navigation Handler
 *
 * Helps to navigate through the routes. Saves the navigation status, animates out the current
 * and more.
 *
 * @returns {{getPrevStep: (function(): *), getNextStep: (function(): *), findIndexByKey: (function(*): number), handleStepClick: handleStepClick}}
 */
export const useNavigation = () => {
  const { appData, updateAppData } = useContext(AppContext);
  const navigate = useNavigate();

  const stepKeys = Object.keys(appData.journeys[appData.currentJourney]);
  const firstStepKey = stepKeys[0];

  const handleStepClick = (stepKey) => {
    if (!stepKey) return;

    const direction = ( appData.direction === 'right' ) ? 'left' : 'right';

    const newAppData = {
      'currentStep': stepKey,
      'direction': direction,
    };

    newAppData[`journeys.${stepKey}.finished`] = false;
    newAppData[`journeys.${stepKey}.answer`] = null;

    let slideElement = document.querySelector('#container__afp-quickcheck-route.slide');
    if (slideElement) {
      slideElement.classList.add('slide--animate', 'slide--out', 'slide--' + appData.direction);

      slideElement.addEventListener("animationend", (e) => {
        slideElement.classList.remove('slide--animate', 'slide--out', 'slide--left', 'slide--right');

        updateAppData(newAppData);
        navigate("/step/" + stepKey);
      }, {once: true});
    }
  };

  const findIndexByKey = (key) => {
    return stepKeys.findIndex((el) => el === key);
  }

  const getPrevStep = () => stepKeys[findIndexByKey(appData.currentStep) - 1] || firstStepKey;
  const getNextStep = () => stepKeys[findIndexByKey(appData.currentStep) + 1] || firstStepKey;

  return {
    handleStepClick,
    getPrevStep,
    getNextStep,
    findIndexByKey
  };
};

